import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink, Navigate } from 'react-router-dom';
import { customerApi } from '@/admin/modules/customers/business';
import { store } from '@/admin/store';
import { t } from '@/core/localization';
import { claimIds as staticClaimIds } from '@/shared/modules/auth/models';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, linkTo, title, claimIds } = appSections.customers;
export const customersRoute = {
    path: rootPath,
    element: _jsx(ProtectedRoute, { claims: claimIds }),
    handle: {
        crumb: () => _jsx(NavLink, { to: linkTo, children: title }),
    },
    // // TODO: later. this approach with preloading is not working right now, since ui component starts automatically read more data
    // // and fetches second page.
    // loader: async () => {
    // 	const promise = store.dispatch(customerApi.endpoints.getCustomers.initiate({ limit: defaultCustomersListPageSize, offset: 0 }));
    // 	// Wait for data to be there.
    // 	await promise;
    // 	// Remove the subscription. The data will stay in cache for 60 seconds and the component can subscribe to it in that timeframe.
    // 	promise.unsubscribe();
    // },
    children: [
        {
            index: true,
            lazy: async () => {
                const { Customers } = await import('@/admin/modules/customers');
                return { Component: Customers };
            },
        },
        { path: ':customerId', element: _jsx(Navigate, { to: "markup", replace: true, relative: "path" }) },
        {
            path: ':customerId',
            lazy: async () => {
                const { CustomerSettings } = await import('@/admin/modules/customers/components/CustomerSettings');
                return { Component: CustomerSettings };
            },
            children: [
                {
                    path: 'markup',
                    lazy: async () => {
                        const { PersonalMarkupTab } = await import('@/admin/modules/customers/components/CustomerSettings');
                        return {
                            element: (
                            // TODO: fix this staticClaimIds later
                            _jsx(ProtectedRoute, { claims: staticClaimIds.filter((claim) => !['CustomerManager', 'CustomerHeadManager'].includes(claim)), children: _jsx(PersonalMarkupTab, {}) })),
                        };
                    },
                    handle: {
                        crumb: ({ params }) => (_jsx(NavLink, { to: `${linkTo}/${params.customerId}/markup`, relative: "path", children: t('customer.settings.label') })),
                    },
                },
                {
                    path: 'orders',
                    children: [
                        {
                            index: true,
                            lazy: async () => {
                                const { OrdersFromFileTab } = await import('@/admin/modules/customers/components/CustomerSettings');
                                return { Component: OrdersFromFileTab };
                            },
                        },
                    ],
                    handle: {
                        crumb: ({ params }) => (_jsx(NavLink, { to: `${linkTo}/${params.customerId}/orders`, relative: "path", children: t('customer.settings.label') })),
                    },
                },
            ],
        },
        {
            // That could be only { path: ':customerId/orders/:ruleId', lazy: ... }, but splitting to path with children is
            // required for breadcrumb.
            path: ':customerId/orders',
            loader: async ({ params: { customerId } }) => {
                if (!Number(customerId))
                    return new Promise((resolve) => resolve({ firstName: '' }));
                // Getting cached data
                const promise = store.dispatch(customerApi.endpoints.getCustomer.initiate(Number(customerId)));
                const { data: customer, isError } = await promise;
                return {
                    firstName: isError || !customer ? '' : customer.firstName,
                };
            },
            handle: {
                crumb: ({ params, loaderData }) => (_jsx(NavLink, { to: `/customers/${params.customerId}/orders`, relative: "path", children: params.ruleId ? (loaderData.firstName ?? t('customer.settings.label')) : t('customer.settings.label') })),
            },
            children: [
                {
                    path: ':ruleId',
                    lazy: async () => {
                        const { OrderImportRuleEdit } = await import('@/admin/modules/customers/components/CustomerSettings/OrderImportRuleEdit');
                        return { Component: OrderImportRuleEdit };
                    },
                    handle: {
                        crumb: ({ params }) => (_jsx(NavLink, { to: `${linkTo}/${params.customerId}/orders/${params.ruleId}`, children: params.ruleId === 'add' ? t('add.new.order.import.rule') : t('edit.order.import.rule') })),
                    },
                },
            ],
            // TODO: fix this line and it will be possible to remove last line (`as RouteObjectWithCrumbs`).
        },
    ],
};
